import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';

const ProductosSinExistencia = () => {
  const [jsonData, setJsonData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const datos = {
        Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "SAMSUNG",
          Modelo: "S22002B",
          Version: "Android 18.125",
          McAdress: null,
          PowerStatus: "84%",
          WifiStatus: "Conected to iphone de Mauricio",
          GPSStatus: "ON",
          GPS: "321|-485|321"
        },
        Usr: {
          Codigo: "",
          UserNickName: "pierril"
        },
        DatosMetodo: {
          NombreMetodo: "ObtenerProductosSinExistenciaFP",
          Datos_Recibidos: ""
        }
      };

      const response = await fetch(
        `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}` 
        //`http://10.10.10.146:8003/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`

      );

      if (!response.ok) throw new Error('Error en la respuesta del servidor');

      const data = await response.json();
      setJsonData(data);

    } catch (error) {
      console.error("Error:", error);
      setError(error.message || "Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  const parseDatosGenerados = (datosGenerados) => {
    try {
      return JSON.parse(datosGenerados);
    } catch (e) {
      console.error("Error parsing datos_Generados:", e);
      return [];
    }
  };
  const BorrarTienda = async (tiendaData) => {
    try {
      const confirmar = window.confirm(`¿Estás seguro de querer borrar la tienda ${tiendaData.Tienda}?`);
      if (!confirmar) return;
      /***********************************************************************************************************************************************/

      setLoading(true);
      setError(null);

      const datos = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321',
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril',
        },
        Metodo: {
          NombreMetodo: 'LimpiarProductos_SinEntregar',
          Datos_Recibidos: JSON.stringify({
            Tienda: tiendaData.Tienda
          }),
          Datos_Generados: '',
        },
      };

      console.log(datos);
      try {

        //http://10.10.10.146:8002/ReceptorDatos?Datos=
        const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        //const response = await fetch('http://10.10.10.146:8003/ReceptorDatos', {
        
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(datos),
        });

        const data = await response.json();
        console.log('Respuesta de la API:', data);

        // Extraer el código de datos_Generados
        const datosGenerados = JSON.parse(data.datos_Generados);
        const codigo = datosGenerados.Codigo; // Asume que el código viene en este campo
        setLoading(false);
        return codigo; // Devolver el código para usarlo en realizarTraslado
      } catch (error) {
        console.error('Error al enviar transferencia:', error);
        setLoading(false);
        throw error; // Propagar el error para manejarlo en realizarTraslado
      } finally {
        setLoading(false);
      }


      /************************************************************************************************************************************************/
    } catch (error) {
      setLoading(false);
      console.error('Error al borrar tienda:', error);
    } finally {
      setLoading(false);
    }
  };
  const BorrarProductoTienda = async (Tienda, ItemCode,ItemName) => {
    try {
      const confirmar = window.confirm(`¿Estás seguro de querer borrar el Producto ${ItemCode} - ${ItemName} de la tienda ${Tienda}?`);
      if (!confirmar) return;
      /***********************************************************************************************************************************************/

      setLoading(true);
      setError(null);

      const datos = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321',
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril',
        },
        Metodo: {
          NombreMetodo: 'Limpiar_ProductosEspecifico_SinEntregar',
          Datos_Recibidos: JSON.stringify({
            Tienda: Tienda,
            Producto: ItemCode
          }),
          Datos_Generados: '',
        },
      };

      console.log(datos);
      try {
        const response = await fetch('https://appcorp.parma.gt/API/ReceptorDatos', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(datos),
        });

        const data = await response.json();
        console.log('Respuesta de la API:', data);

        // Extraer el código de datos_Generados
        const datosGenerados = JSON.parse(data.datos_Generados);
        const codigo = datosGenerados.Codigo; // Asume que el código viene en este campo
        setLoading(false);
        return codigo; // Devolver el código para usarlo en realizarTraslado
      } catch (error) {
        console.error('Error al enviar transferencia:', error);
        setLoading(false);
        throw error; // Propagar el error para manejarlo en realizarTraslado
      } finally {
        setLoading(false);
      }
      /************************************************************************************************************************************************/
   } catch (error) {
      setLoading(false);
      console.error('Error al borrar tienda:', error);
    } finally {
      fetchData();
      setLoading(false);
    }

  };
  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4" gutterBottom>
        📦 Productos sin Existencia
      </Typography>

      <Box display="flex" alignItems="center" gap={2} marginBottom={3}>
        <Button
          variant="contained"
          onClick={fetchData}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? "Buscando..." : "Buscar Productos"}
        </Button>

        {error && (
          <Typography color="error">{error}</Typography>
        )}
      </Box>

      {jsonData && jsonData.datos_Generados && (
        <Box>
          {parseDatosGenerados(jsonData.datos_Generados).map((tiendaData, index) => (
            <Accordion key={index} defaultExpanded style={{ marginBottom: '20px' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <Typography variant="h6">
                    TIENDA: {tiendaData.Tienda || 'No especificada'}
                  </Typography>
                  <Button
                    variant="contained"
                    color="warning"
                    disabled={true}  // Botón siempre desactivado
                    onClick={(e) => {
                      e.stopPropagation();
                      BorrarTienda(tiendaData);
                    }}
                    startIcon={<CachedIcon />}
                  >
                    Procesar Tienda
                  </Button>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell><strong>Bodega</strong></TableCell>
                        <TableCell><strong>Tipo</strong></TableCell>
                        <TableCell><strong>Código</strong></TableCell>
                        <TableCell><strong>Producto</strong></TableCell>
                        <TableCell><strong>Cantidad</strong></TableCell>
                        <TableCell><strong>Subclasificación</strong></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tiendaData.Detalles && tiendaData.Detalles.length > 0 ? (
                        tiendaData.Detalles.map((item, itemIndex) => (
                          <TableRow key={itemIndex} hover>
                            <TableCell>{item.Bodega}</TableCell>
                            <TableCell>{item.TreeType}</TableCell>
                            <TableCell>{item.ItemCode}</TableCell>
                            <TableCell>{item.ItemName}</TableCell>
                            <TableCell>{item.Pendiente.toFixed(6)}</TableCell>
                            <TableCell>{item.subclasificacion}</TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                color="info"
                                 disabled={true}  // Botón siempre desactivado
                                onClick={(e) => {
                                  e.stopPropagation(); // Esto evita que el Accordion se expanda/contraiga al hacer clic
                                  BorrarProductoTienda(tiendaData.Tienda, item.ItemCode,item.ItemName);
                                }}
                              startIcon={<CachedIcon />} 
                              >Procesar</Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} align="center">No hay productos sin existencia</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}


    </div>
  );
};

export default ProductosSinExistencia;